module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/scissors-d51313c6cbcac525696aed0afb689bae.svg";